<script setup>
import {computed, onMounted, onUnmounted, ref} from "vue";
import needsService from "@/services/needs.service";
import NeedsUpdatesAIItem from "@/views/needs/needs/NeedsUpdatesAIItem.vue";

const GAP_PX = 0
const windowWidth = ref(window.innerWidth);

const VISIBLE_SLIDES = computed(() => {
    if (windowWidth.value <= 640) return 1
    if (windowWidth.value <= 880) return 2
    return 3.6
})

const slides = ref([])

const currentIndex = ref(0)
const maxIndex = computed(() => slides.value.length - Math.floor(VISIBLE_SLIDES.value))

const slideWidthPercent = computed(() => 100 / VISIBLE_SLIDES.value)

const slideStyle = computed(() => ({
    flex: `0 0 calc(${slideWidthPercent.value}% - ${GAP_PX}px)`,
    maxWidth: `calc(${slideWidthPercent.value}% - ${GAP_PX}px)`,
}))

const trackStyle = computed(() => ({
    transform: `translateX(calc(-${currentIndex.value * (100 / VISIBLE_SLIDES.value)}% - ${currentIndex.value * GAP_PX}px))`,
    transition: 'transform 0.4s ease',
}))

onMounted(() => {
    window.addEventListener('resize', onResize);

    getTodos();
})

onUnmounted(() => window.removeEventListener('resize', onResize))

function onResize() {
    windowWidth.value = window.innerWidth
}

function prev() { if (currentIndex.value > 0) currentIndex.value-- }
function next() { if (currentIndex.value < maxIndex.value) currentIndex.value++ }

const touchStartX = ref(0)
function onTouchStart(e) { touchStartX.value = e.touches[0].clientX }
function onTouchMove(e) { e.preventDefault() }
function onTouchEnd(e) {
    const delta = touchStartX.value - e.changedTouches[0].clientX
    if (delta > 50) next()
    else if (delta < -50) prev()
}

async function getTodos() {
    const {data} = await needsService.getTodos();

    slides.value = data;
}
</script>

<template>
    <div v-if="slides.length">
        <h3 class="heading3 heading3--updates">To Do</h3>

        <div class="carousel-wrapper">
            <div class="carousel-track-container" ref="trackContainer">
                <div
                    class="carousel-track"
                    :style="trackStyle"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="onTouchEnd"
                >
                    <NeedsUpdatesAIItem
                        v-for="(slide, index) in slides"
                        :key="index"
                        :need="slide"
                        class="carousel-slide"
                        :style="slideStyle"
                    />

<!--                        <div v-if="index === 0" class="carousel-slide__item">-->
<!--                            <div class="card-needs">-->
<!--                                <div class="card-needs__content">-->
<!--                                    <h5 class="heading5 heading5&#45;&#45;secondary">Recycled plastic packaging</h5>-->
<!--                                    <p>10 new AI matches</p>-->
<!--                                    <ul class="list-matches">-->
<!--                                        <li><a href="#"><img src="https://sp-images-dev.s3.amazonaws.com/173765293067927ac244c44.jpeg" alt="" /></a></li>-->
<!--                                        <li><a href="#"><img src="https://sp-images-dev.s3.amazonaws.com/16496616736253d6e9c93ad.png" alt="" /></a></li>-->
<!--                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>-->
<!--                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>-->
<!--                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>-->
<!--                                        <li><a href="#"><img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" /></a></li>-->
<!--                                    </ul>-->
<!--                                </div>-->
<!--                                <footer class="card-needs__footer">-->
<!--                                    <a href="#" class="link-arrow">Review</a>-->
<!--                                </footer>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div v-else-if="index === 1" class="carousel-slide__item">-->
<!--                            <div class="card-needs">-->
<!--                                <div class="card-needs__content">-->
<!--                                    <h5 class="heading5 heading5&#45;&#45;secondary">Recycled plastic packaging</h5>-->
<!--                                    <div class="card-needs__notification card-needs__notification&#45;&#45;active">-->
<!--                                        <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />-->
<!--                                    </div>-->
<!--                                    <p>10 new AI matches</p>-->
<!--                                </div>-->
<!--                                <footer class="card-needs__footer">-->
<!--                                    <a href="#" class="link-arrow">Review</a>-->
<!--                                </footer>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div v-else-if="index === 3" class="carousel-slide__item">-->
<!--                            <div class="card-needs">-->
<!--                                <div class="card-needs__content">-->
<!--                                    <h5 class="heading5 heading5&#45;&#45;secondary">Recycled plastic packaging</h5>-->
<!--                                    <p>10 new AI matches</p>-->
<!--                                </div>-->
<!--                                <footer class="card-needs__footer">-->
<!--                                    <a href="#" class="link-arrow">Review</a>-->
<!--                                </footer>-->
<!--                            </div>-->
<!--                        </div>-->
                </div>
            </div>

            <button class="carousel-btn carousel-btn--prev" @click="prev" :disabled="currentIndex === 0"></button>
            <button class="carousel-btn carousel-btn--next" @click="next" :disabled="currentIndex >= maxIndex"></button>
        </div>
    </div>
</template>

<style scoped>

</style>
